import * as ReactDOM from "react-dom/client";
import "./index.css";

import { initReactI18next } from "react-i18next";
import * as arTranslation from "./assets/locales/ar/translation.json";
import * as enTranslation from "./assets/locales/en/translation.json";
import i18n from "i18next";
import App from "./App";
import { UserProvider } from "./contexts/user.context.tsx";
import { BrowserRouter } from "react-router-dom";
import SemiTheme from "./theme/semidark.theme.tsx";
import { ThemeProvider } from "styled-components";
import { CommanDataProvider } from "./contexts/commanData.context.tsx";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-international-phone/style.css";
import { ReportFormProvider } from "./routes/dashboard/reportsAnswers/context/reportFormContext.tsx";
import { NuqsAdapter } from "nuqs/adapters/react";
import ErrorBoundary from "./utils/ErrorBoundary.tsx";
import { StrictMode } from "react";

i18n.use(initReactI18next).init({
  lng: localStorage.getItem("lang") || "en", // Default language
  fallbackLng: "en", // Fallback language
  resources: {
    en: {
      translation: enTranslation,
    },
    ar: {
      translation: arTranslation,
    },
  },
});

document.body.lang = i18n.language;
document.body.dir = i18n.dir();

i18n.on("languageChanged", (lng) => {
  if (lng === "ar") {
    document.body.lang = "ar";
    document.body.dir = "rtl";
    localStorage.setItem("lang", "ar");
  } else {
    document.body.lang = "en";
    document.body.dir = "ltr";
    localStorage.setItem("lang", "en");
  }
});

// console.log(typeof import.meta.env.VITE_PROD, "import.meta.env.VITE_PROD")

if (import.meta.env.VITE_PROD == "true") {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <ErrorBoundary>
      <NuqsAdapter>
        <UserProvider>
          <BrowserRouter>
            <CommanDataProvider>
              <ThemeProvider theme={SemiTheme}>
                <ReportFormProvider>
                  <App />
                </ReportFormProvider>
              </ThemeProvider>
            </CommanDataProvider>
          </BrowserRouter>
        </UserProvider>
      </NuqsAdapter>
    </ErrorBoundary>
  );
} else {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <ErrorBoundary>
      <NuqsAdapter>
        <UserProvider>
          <BrowserRouter>
            <CommanDataProvider>
              <ThemeProvider theme={SemiTheme}>
                <ReportFormProvider>
                  <App />
                </ReportFormProvider>
              </ThemeProvider>
            </CommanDataProvider>
          </BrowserRouter>
        </UserProvider>
      </NuqsAdapter>
    </ErrorBoundary>
  );
}
